import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';

export const OTP_INFO_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_1091,
  height: FoundationsCobrandedRegularTheme.size_300,
};

export const OTP_NUMBER_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_850,
  height: FoundationsCobrandedRegularTheme.size_300,
};

export const OTP_CODE_INFO_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_800,
  height: FoundationsCobrandedRegularTheme.size_300,
};
export const OTP_CODE_NUMBER_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: '100%',
  height: FoundationsCobrandedRegularTheme.size_450,
};
export const OTP_CODE_NEW_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_1050,
  height: FoundationsCobrandedRegularTheme.size_300,
};
